/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BatchUpdateParamsVO } from '../model';
// @ts-ignore
import { Feature } from '../model';
// @ts-ignore
import { FeatureBatchProgressVO } from '../model';
// @ts-ignore
import { FeatureWrapperVO } from '../model';
// @ts-ignore
import { LayerAttributeVO } from '../model';
// @ts-ignore
import { LayerCategoryVO } from '../model';
// @ts-ignore
import { LogAtributVO } from '../model';
// @ts-ignore
import { LogDokumentVO } from '../model';
// @ts-ignore
import { LogVO } from '../model';
// @ts-ignore
import { UserLayerFilterVO } from '../model';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * UserLayersControllerApi - axios parameter creator
 * @export
 */
export const UserLayersControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} layerId ID vrstvy
         * @param {string} featureId ID featury
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLayerFeature: async (layerId: number, featureId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('deleteLayerFeature', 'layerId', layerId)
            // verify required parameter 'featureId' is not null or undefined
            assertParamExists('deleteLayerFeature', 'featureId', featureId)
            const localVarPath = `/api/user-layers/layer/{layerId}/data/delete`
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (featureId !== undefined) {
                localVarQueryParameter['featureId'] = featureId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} layerId ID vrstvy
         * @param {Array<string>} [requestBody] Seznam ID featur, které se mají smazat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLayerFeatureBatch: async (layerId: number, requestBody?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('deleteLayerFeatureBatch', 'layerId', layerId)
            const localVarPath = `/api/user-layers/layer/{layerId}/data/delete/batch`
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} layerId 
         * @param {number} idLog 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAtributLog: async (layerId: number, idLog: number, context?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('getAtributLog', 'layerId', layerId)
            // verify required parameter 'idLog' is not null or undefined
            assertParamExists('getAtributLog', 'idLog', idLog)
            const localVarPath = `/api/user-layers/{layerId}/log/{idLog}/atribut`
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)))
                .replace(`{${"idLog"}}`, encodeURIComponent(String(idLog)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} layerId 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories: async (layerId: number, context?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('getCategories', 'layerId', layerId)
            const localVarPath = `/api/user-layers/layer/{layerId}/categories`
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} layerId ID vrstvy
         * @param {number} [actionId] ID akce
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getData: async (layerId: number, actionId?: number, context?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('getData', 'layerId', layerId)
            const localVarPath = `/api/user-layers/layer/{layerId}/data/all`
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (actionId !== undefined) {
                localVarQueryParameter['actionId'] = actionId;
            }

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} layerId 
         * @param {number} [idAkce] 
         * @param {string} [context] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataByIds: async (layerId: number, idAkce?: number, context?: string, requestBody?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('getDataByIds', 'layerId', layerId)
            const localVarPath = `/api/user-layers/layer/{layerId}/data`
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idAkce !== undefined) {
                localVarQueryParameter['idAkce'] = idAkce;
            }

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} layerId 
         * @param {string} idData 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataLog: async (layerId: number, idData: string, context?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('getDataLog', 'layerId', layerId)
            // verify required parameter 'idData' is not null or undefined
            assertParamExists('getDataLog', 'idData', idData)
            const localVarPath = `/api/user-layers/{layerId}/data/{idData}/log`
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)))
                .replace(`{${"idData"}}`, encodeURIComponent(String(idData)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} layerId 
         * @param {number} idLog 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDokumentLog: async (layerId: number, idLog: number, context?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('getDokumentLog', 'layerId', layerId)
            // verify required parameter 'idLog' is not null or undefined
            assertParamExists('getDokumentLog', 'idLog', idLog)
            const localVarPath = `/userLayers/{layerId}/log/{idLog}/dokument`
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)))
                .replace(`{${"idLog"}}`, encodeURIComponent(String(idLog)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Průběh probíhající hromadné editace (updateLayerFeaturesBatch) spuštěné se stejným progressId. Dotaz je long-polling – server odpoví, až se průběh znatelně posune, dávka skončí, nebo vyprší čekání.
         * @param {string} progressId ID průběhu předané do updateLayerFeaturesBatch
         * @param {number} [knownDone] Počet zpracovaných featur, který klient už zná – server odpoví, až bude mít co nového říct
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureBatchProgress: async (progressId: string, knownDone?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'progressId' is not null or undefined
            assertParamExists('getFeatureBatchProgress', 'progressId', progressId)
            const localVarPath = `/api/user-layers/batch-progress/{progressId}`
                .replace(`{${"progressId"}}`, encodeURIComponent(String(progressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (knownDone !== undefined) {
                localVarQueryParameter['knownDone'] = knownDone;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} layerId 
         * @param {string} [context] 
         * @param {UserLayerFilterVO} [userLayerFilterVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureIds: async (layerId: number, context?: string, userLayerFilterVO?: UserLayerFilterVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('getFeatureIds', 'layerId', layerId)
            const localVarPath = `/api/user-layers/layer/{layerId}/data/all/ids`
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userLayerFilterVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} layerId 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLayerAttributes: async (layerId: number, context?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('getLayerAttributes', 'layerId', layerId)
            const localVarPath = `/api/user-layers/layer/{layerId}/attributes`
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} layerId 
         * @param {string} featureId 
         * @param {number} [actionId] 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLayerDetail: async (layerId: number, featureId: string, actionId?: number, context?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('getLayerDetail', 'layerId', layerId)
            // verify required parameter 'featureId' is not null or undefined
            assertParamExists('getLayerDetail', 'featureId', featureId)
            const localVarPath = `/api/user-layers/layer/{layerId}/detail`
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (featureId !== undefined) {
                localVarQueryParameter['featureId'] = featureId;
            }

            if (actionId !== undefined) {
                localVarQueryParameter['actionId'] = actionId;
            }

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} layerId ID vrstvy
         * @param {number} [actionId] ID akce
         * @param {FeatureWrapperVO} [featureWrapperVO] Uložení nové featury
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveLayerFeature: async (layerId: number, actionId?: number, featureWrapperVO?: FeatureWrapperVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('saveLayerFeature', 'layerId', layerId)
            const localVarPath = `/api/user-layers/layer/{layerId}/data/save`
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (actionId !== undefined) {
                localVarQueryParameter['actionId'] = actionId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(featureWrapperVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} layerId ID vrstvy
         * @param {number} [actionId] ID akce
         * @param {FeatureWrapperVO} [featureWrapperVO] Editace featury
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLayerFeature: async (layerId: number, actionId?: number, featureWrapperVO?: FeatureWrapperVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('updateLayerFeature', 'layerId', layerId)
            const localVarPath = `/api/user-layers/layer/{layerId}/data/update`
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (actionId !== undefined) {
                localVarQueryParameter['actionId'] = actionId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(featureWrapperVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} layerId ID vrstvy
         * @param {number} [actionId] ID akce
         * @param {BatchUpdateParamsVO} [batchUpdateParamsVO] Hromadná editace featur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLayerFeatureBatch: async (layerId: number, actionId?: number, batchUpdateParamsVO?: BatchUpdateParamsVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('updateLayerFeatureBatch', 'layerId', layerId)
            const localVarPath = `/api/user-layers/layer/{layerId}/data/update/batch`
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (actionId !== undefined) {
                localVarQueryParameter['actionId'] = actionId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchUpdateParamsVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} layerId ID vrstvy
         * @param {number} [actionId] ID akce
         * @param {string} [progressId] Klientem vygenerované ID, pod kterým lze průběh ukládání dotazovat přes getFeatureBatchProgress
         * @param {Array<FeatureWrapperVO>} [featureWrapperVO] Hromadná editace více featur, každá s vlastní geometrií (např. přesun mnoha objektů najednou). Uloží se v jedné transakci.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLayerFeaturesBatch: async (layerId: number, actionId?: number, progressId?: string, featureWrapperVO?: Array<FeatureWrapperVO>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('updateLayerFeaturesBatch', 'layerId', layerId)
            const localVarPath = `/api/user-layers/layer/{layerId}/data/update/features/batch`
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (actionId !== undefined) {
                localVarQueryParameter['actionId'] = actionId;
            }

            if (progressId !== undefined) {
                localVarQueryParameter['progressId'] = progressId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(featureWrapperVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserLayersControllerApi - functional programming interface
 * @export
 */
export const UserLayersControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserLayersControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} layerId ID vrstvy
         * @param {string} featureId ID featury
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLayerFeature(layerId: number, featureId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLayerFeature(layerId, featureId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} layerId ID vrstvy
         * @param {Array<string>} [requestBody] Seznam ID featur, které se mají smazat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLayerFeatureBatch(layerId: number, requestBody?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLayerFeatureBatch(layerId, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} layerId 
         * @param {number} idLog 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAtributLog(layerId: number, idLog: number, context?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LogAtributVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getAtributLog(layerId, idLog, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} layerId 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategories(layerId: number, context?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LayerCategoryVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategories(layerId, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} layerId ID vrstvy
         * @param {number} [actionId] ID akce
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getData(layerId: number, actionId?: number, context?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Feature>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getData(layerId, actionId, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} layerId 
         * @param {number} [idAkce] 
         * @param {string} [context] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataByIds(layerId: number, idAkce?: number, context?: string, requestBody?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Feature>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataByIds(layerId, idAkce, context, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} layerId 
         * @param {string} idData 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataLog(layerId: number, idData: string, context?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LogVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataLog(layerId, idData, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} layerId 
         * @param {number} idLog 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDokumentLog(layerId: number, idLog: number, context?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LogDokumentVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getDokumentLog(layerId, idLog, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Průběh probíhající hromadné editace (updateLayerFeaturesBatch) spuštěné se stejným progressId. Dotaz je long-polling – server odpoví, až se průběh znatelně posune, dávka skončí, nebo vyprší čekání.
         * @param {string} progressId ID průběhu předané do updateLayerFeaturesBatch
         * @param {number} [knownDone] Počet zpracovaných featur, který klient už zná – server odpoví, až bude mít co nového říct
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeatureBatchProgress(progressId: string, knownDone?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureBatchProgressVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeatureBatchProgress(progressId, knownDone, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} layerId 
         * @param {string} [context] 
         * @param {UserLayerFilterVO} [userLayerFilterVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeatureIds(layerId: number, context?: string, userLayerFilterVO?: UserLayerFilterVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeatureIds(layerId, context, userLayerFilterVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} layerId 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLayerAttributes(layerId: number, context?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LayerAttributeVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getLayerAttributes(layerId, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} layerId 
         * @param {string} featureId 
         * @param {number} [actionId] 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLayerDetail(layerId: number, featureId: string, actionId?: number, context?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getLayerDetail(layerId, featureId, actionId, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} layerId ID vrstvy
         * @param {number} [actionId] ID akce
         * @param {FeatureWrapperVO} [featureWrapperVO] Uložení nové featury
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveLayerFeature(layerId: number, actionId?: number, featureWrapperVO?: FeatureWrapperVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.saveLayerFeature(layerId, actionId, featureWrapperVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} layerId ID vrstvy
         * @param {number} [actionId] ID akce
         * @param {FeatureWrapperVO} [featureWrapperVO] Editace featury
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLayerFeature(layerId: number, actionId?: number, featureWrapperVO?: FeatureWrapperVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLayerFeature(layerId, actionId, featureWrapperVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} layerId ID vrstvy
         * @param {number} [actionId] ID akce
         * @param {BatchUpdateParamsVO} [batchUpdateParamsVO] Hromadná editace featur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLayerFeatureBatch(layerId: number, actionId?: number, batchUpdateParamsVO?: BatchUpdateParamsVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLayerFeatureBatch(layerId, actionId, batchUpdateParamsVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} layerId ID vrstvy
         * @param {number} [actionId] ID akce
         * @param {string} [progressId] Klientem vygenerované ID, pod kterým lze průběh ukládání dotazovat přes getFeatureBatchProgress
         * @param {Array<FeatureWrapperVO>} [featureWrapperVO] Hromadná editace více featur, každá s vlastní geometrií (např. přesun mnoha objektů najednou). Uloží se v jedné transakci.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLayerFeaturesBatch(layerId: number, actionId?: number, progressId?: string, featureWrapperVO?: Array<FeatureWrapperVO>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLayerFeaturesBatch(layerId, actionId, progressId, featureWrapperVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserLayersControllerApi - factory interface
 * @export
 */
export const UserLayersControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserLayersControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} layerId ID vrstvy
         * @param {string} featureId ID featury
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLayerFeature(layerId: number, featureId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteLayerFeature(layerId, featureId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} layerId ID vrstvy
         * @param {Array<string>} [requestBody] Seznam ID featur, které se mají smazat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLayerFeatureBatch(layerId: number, requestBody?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.deleteLayerFeatureBatch(layerId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} layerId 
         * @param {number} idLog 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAtributLog(layerId: number, idLog: number, context?: string, options?: any): AxiosPromise<Array<LogAtributVO>> {
            return localVarFp.getAtributLog(layerId, idLog, context, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} layerId 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories(layerId: number, context?: string, options?: any): AxiosPromise<Array<LayerCategoryVO>> {
            return localVarFp.getCategories(layerId, context, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} layerId ID vrstvy
         * @param {number} [actionId] ID akce
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getData(layerId: number, actionId?: number, context?: string, options?: any): AxiosPromise<Array<Feature>> {
            return localVarFp.getData(layerId, actionId, context, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} layerId 
         * @param {number} [idAkce] 
         * @param {string} [context] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataByIds(layerId: number, idAkce?: number, context?: string, requestBody?: Array<string>, options?: any): AxiosPromise<Array<Feature>> {
            return localVarFp.getDataByIds(layerId, idAkce, context, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} layerId 
         * @param {string} idData 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataLog(layerId: number, idData: string, context?: string, options?: any): AxiosPromise<Array<LogVO>> {
            return localVarFp.getDataLog(layerId, idData, context, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} layerId 
         * @param {number} idLog 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDokumentLog(layerId: number, idLog: number, context?: string, options?: any): AxiosPromise<Array<LogDokumentVO>> {
            return localVarFp.getDokumentLog(layerId, idLog, context, options).then((request) => request(axios, basePath));
        },
        /**
         * Průběh probíhající hromadné editace (updateLayerFeaturesBatch) spuštěné se stejným progressId. Dotaz je long-polling – server odpoví, až se průběh znatelně posune, dávka skončí, nebo vyprší čekání.
         * @param {string} progressId ID průběhu předané do updateLayerFeaturesBatch
         * @param {number} [knownDone] Počet zpracovaných featur, který klient už zná – server odpoví, až bude mít co nového říct
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureBatchProgress(progressId: string, knownDone?: number, options?: any): AxiosPromise<FeatureBatchProgressVO> {
            return localVarFp.getFeatureBatchProgress(progressId, knownDone, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} layerId 
         * @param {string} [context] 
         * @param {UserLayerFilterVO} [userLayerFilterVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureIds(layerId: number, context?: string, userLayerFilterVO?: UserLayerFilterVO, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getFeatureIds(layerId, context, userLayerFilterVO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} layerId 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLayerAttributes(layerId: number, context?: string, options?: any): AxiosPromise<Array<LayerAttributeVO>> {
            return localVarFp.getLayerAttributes(layerId, context, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} layerId 
         * @param {string} featureId 
         * @param {number} [actionId] 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLayerDetail(layerId: number, featureId: string, actionId?: number, context?: string, options?: any): AxiosPromise<object> {
            return localVarFp.getLayerDetail(layerId, featureId, actionId, context, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} layerId ID vrstvy
         * @param {number} [actionId] ID akce
         * @param {FeatureWrapperVO} [featureWrapperVO] Uložení nové featury
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveLayerFeature(layerId: number, actionId?: number, featureWrapperVO?: FeatureWrapperVO, options?: any): AxiosPromise<number> {
            return localVarFp.saveLayerFeature(layerId, actionId, featureWrapperVO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} layerId ID vrstvy
         * @param {number} [actionId] ID akce
         * @param {FeatureWrapperVO} [featureWrapperVO] Editace featury
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLayerFeature(layerId: number, actionId?: number, featureWrapperVO?: FeatureWrapperVO, options?: any): AxiosPromise<void> {
            return localVarFp.updateLayerFeature(layerId, actionId, featureWrapperVO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} layerId ID vrstvy
         * @param {number} [actionId] ID akce
         * @param {BatchUpdateParamsVO} [batchUpdateParamsVO] Hromadná editace featur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLayerFeatureBatch(layerId: number, actionId?: number, batchUpdateParamsVO?: BatchUpdateParamsVO, options?: any): AxiosPromise<void> {
            return localVarFp.updateLayerFeatureBatch(layerId, actionId, batchUpdateParamsVO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} layerId ID vrstvy
         * @param {number} [actionId] ID akce
         * @param {string} [progressId] Klientem vygenerované ID, pod kterým lze průběh ukládání dotazovat přes getFeatureBatchProgress
         * @param {Array<FeatureWrapperVO>} [featureWrapperVO] Hromadná editace více featur, každá s vlastní geometrií (např. přesun mnoha objektů najednou). Uloží se v jedné transakci.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLayerFeaturesBatch(layerId: number, actionId?: number, progressId?: string, featureWrapperVO?: Array<FeatureWrapperVO>, options?: any): AxiosPromise<void> {
            return localVarFp.updateLayerFeaturesBatch(layerId, actionId, progressId, featureWrapperVO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserLayersControllerApi - interface
 * @export
 * @interface UserLayersControllerApi
 */
export interface UserLayersControllerApiInterface {
    /**
     * 
     * @param {number} layerId ID vrstvy
     * @param {string} featureId ID featury
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApiInterface
     */
    deleteLayerFeature(layerId: number, featureId: string, options?: any): AxiosPromise<void>;

    /**
     * 
     * @param {number} layerId ID vrstvy
     * @param {Array<string>} [requestBody] Seznam ID featur, které se mají smazat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApiInterface
     */
    deleteLayerFeatureBatch(layerId: number, requestBody?: Array<string>, options?: any): AxiosPromise<void>;

    /**
     * 
     * @param {number} layerId 
     * @param {number} idLog 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApiInterface
     */
    getAtributLog(layerId: number, idLog: number, context?: string, options?: any): AxiosPromise<Array<LogAtributVO>>;

    /**
     * 
     * @param {number} layerId 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApiInterface
     */
    getCategories(layerId: number, context?: string, options?: any): AxiosPromise<Array<LayerCategoryVO>>;

    /**
     * 
     * @param {number} layerId ID vrstvy
     * @param {number} [actionId] ID akce
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApiInterface
     */
    getData(layerId: number, actionId?: number, context?: string, options?: any): AxiosPromise<Array<Feature>>;

    /**
     * 
     * @param {number} layerId 
     * @param {number} [idAkce] 
     * @param {string} [context] 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApiInterface
     */
    getDataByIds(layerId: number, idAkce?: number, context?: string, requestBody?: Array<string>, options?: any): AxiosPromise<Array<Feature>>;

    /**
     * 
     * @param {number} layerId 
     * @param {string} idData 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApiInterface
     */
    getDataLog(layerId: number, idData: string, context?: string, options?: any): AxiosPromise<Array<LogVO>>;

    /**
     * 
     * @param {number} layerId 
     * @param {number} idLog 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApiInterface
     */
    getDokumentLog(layerId: number, idLog: number, context?: string, options?: any): AxiosPromise<Array<LogDokumentVO>>;

    /**
     * Průběh probíhající hromadné editace (updateLayerFeaturesBatch) spuštěné se stejným progressId. Dotaz je long-polling – server odpoví, až se průběh znatelně posune, dávka skončí, nebo vyprší čekání.
     * @param {string} progressId ID průběhu předané do updateLayerFeaturesBatch
     * @param {number} [knownDone] Počet zpracovaných featur, který klient už zná – server odpoví, až bude mít co nového říct
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApiInterface
     */
    getFeatureBatchProgress(progressId: string, knownDone?: number, options?: any): AxiosPromise<FeatureBatchProgressVO>;

    /**
     * 
     * @param {number} layerId 
     * @param {string} [context] 
     * @param {UserLayerFilterVO} [userLayerFilterVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApiInterface
     */
    getFeatureIds(layerId: number, context?: string, userLayerFilterVO?: UserLayerFilterVO, options?: any): AxiosPromise<Array<string>>;

    /**
     * 
     * @param {number} layerId 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApiInterface
     */
    getLayerAttributes(layerId: number, context?: string, options?: any): AxiosPromise<Array<LayerAttributeVO>>;

    /**
     * 
     * @param {number} layerId 
     * @param {string} featureId 
     * @param {number} [actionId] 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApiInterface
     */
    getLayerDetail(layerId: number, featureId: string, actionId?: number, context?: string, options?: any): AxiosPromise<object>;

    /**
     * 
     * @param {number} layerId ID vrstvy
     * @param {number} [actionId] ID akce
     * @param {FeatureWrapperVO} [featureWrapperVO] Uložení nové featury
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApiInterface
     */
    saveLayerFeature(layerId: number, actionId?: number, featureWrapperVO?: FeatureWrapperVO, options?: any): AxiosPromise<number>;

    /**
     * 
     * @param {number} layerId ID vrstvy
     * @param {number} [actionId] ID akce
     * @param {FeatureWrapperVO} [featureWrapperVO] Editace featury
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApiInterface
     */
    updateLayerFeature(layerId: number, actionId?: number, featureWrapperVO?: FeatureWrapperVO, options?: any): AxiosPromise<void>;

    /**
     * 
     * @param {number} layerId ID vrstvy
     * @param {number} [actionId] ID akce
     * @param {BatchUpdateParamsVO} [batchUpdateParamsVO] Hromadná editace featur
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApiInterface
     */
    updateLayerFeatureBatch(layerId: number, actionId?: number, batchUpdateParamsVO?: BatchUpdateParamsVO, options?: any): AxiosPromise<void>;

    /**
     * 
     * @param {number} layerId ID vrstvy
     * @param {number} [actionId] ID akce
     * @param {string} [progressId] Klientem vygenerované ID, pod kterým lze průběh ukládání dotazovat přes getFeatureBatchProgress
     * @param {Array<FeatureWrapperVO>} [featureWrapperVO] Hromadná editace více featur, každá s vlastní geometrií (např. přesun mnoha objektů najednou). Uloží se v jedné transakci.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApiInterface
     */
    updateLayerFeaturesBatch(layerId: number, actionId?: number, progressId?: string, featureWrapperVO?: Array<FeatureWrapperVO>, options?: any): AxiosPromise<void>;

}

/**
 * UserLayersControllerApi - object-oriented interface
 * @export
 * @class UserLayersControllerApi
 * @extends {BaseAPI}
 */
export class UserLayersControllerApi extends BaseAPI implements UserLayersControllerApiInterface {
    /**
     * 
     * @param {number} layerId ID vrstvy
     * @param {string} featureId ID featury
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApi
     */
    public deleteLayerFeature(layerId: number, featureId: string, options?: any) {
        return UserLayersControllerApiFp(this.configuration).deleteLayerFeature(layerId, featureId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} layerId ID vrstvy
     * @param {Array<string>} [requestBody] Seznam ID featur, které se mají smazat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApi
     */
    public deleteLayerFeatureBatch(layerId: number, requestBody?: Array<string>, options?: any) {
        return UserLayersControllerApiFp(this.configuration).deleteLayerFeatureBatch(layerId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} layerId 
     * @param {number} idLog 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApi
     */
    public getAtributLog(layerId: number, idLog: number, context?: string, options?: any) {
        return UserLayersControllerApiFp(this.configuration).getAtributLog(layerId, idLog, context, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} layerId 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApi
     */
    public getCategories(layerId: number, context?: string, options?: any) {
        return UserLayersControllerApiFp(this.configuration).getCategories(layerId, context, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} layerId ID vrstvy
     * @param {number} [actionId] ID akce
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApi
     */
    public getData(layerId: number, actionId?: number, context?: string, options?: any) {
        return UserLayersControllerApiFp(this.configuration).getData(layerId, actionId, context, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} layerId 
     * @param {number} [idAkce] 
     * @param {string} [context] 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApi
     */
    public getDataByIds(layerId: number, idAkce?: number, context?: string, requestBody?: Array<string>, options?: any) {
        return UserLayersControllerApiFp(this.configuration).getDataByIds(layerId, idAkce, context, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} layerId 
     * @param {string} idData 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApi
     */
    public getDataLog(layerId: number, idData: string, context?: string, options?: any) {
        return UserLayersControllerApiFp(this.configuration).getDataLog(layerId, idData, context, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} layerId 
     * @param {number} idLog 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApi
     */
    public getDokumentLog(layerId: number, idLog: number, context?: string, options?: any) {
        return UserLayersControllerApiFp(this.configuration).getDokumentLog(layerId, idLog, context, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Průběh probíhající hromadné editace (updateLayerFeaturesBatch) spuštěné se stejným progressId. Dotaz je long-polling – server odpoví, až se průběh znatelně posune, dávka skončí, nebo vyprší čekání.
     * @param {string} progressId ID průběhu předané do updateLayerFeaturesBatch
     * @param {number} [knownDone] Počet zpracovaných featur, který klient už zná – server odpoví, až bude mít co nového říct
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApi
     */
    public getFeatureBatchProgress(progressId: string, knownDone?: number, options?: any) {
        return UserLayersControllerApiFp(this.configuration).getFeatureBatchProgress(progressId, knownDone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} layerId 
     * @param {string} [context] 
     * @param {UserLayerFilterVO} [userLayerFilterVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApi
     */
    public getFeatureIds(layerId: number, context?: string, userLayerFilterVO?: UserLayerFilterVO, options?: any) {
        return UserLayersControllerApiFp(this.configuration).getFeatureIds(layerId, context, userLayerFilterVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} layerId 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApi
     */
    public getLayerAttributes(layerId: number, context?: string, options?: any) {
        return UserLayersControllerApiFp(this.configuration).getLayerAttributes(layerId, context, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} layerId 
     * @param {string} featureId 
     * @param {number} [actionId] 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApi
     */
    public getLayerDetail(layerId: number, featureId: string, actionId?: number, context?: string, options?: any) {
        return UserLayersControllerApiFp(this.configuration).getLayerDetail(layerId, featureId, actionId, context, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} layerId ID vrstvy
     * @param {number} [actionId] ID akce
     * @param {FeatureWrapperVO} [featureWrapperVO] Uložení nové featury
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApi
     */
    public saveLayerFeature(layerId: number, actionId?: number, featureWrapperVO?: FeatureWrapperVO, options?: any) {
        return UserLayersControllerApiFp(this.configuration).saveLayerFeature(layerId, actionId, featureWrapperVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} layerId ID vrstvy
     * @param {number} [actionId] ID akce
     * @param {FeatureWrapperVO} [featureWrapperVO] Editace featury
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApi
     */
    public updateLayerFeature(layerId: number, actionId?: number, featureWrapperVO?: FeatureWrapperVO, options?: any) {
        return UserLayersControllerApiFp(this.configuration).updateLayerFeature(layerId, actionId, featureWrapperVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} layerId ID vrstvy
     * @param {number} [actionId] ID akce
     * @param {BatchUpdateParamsVO} [batchUpdateParamsVO] Hromadná editace featur
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApi
     */
    public updateLayerFeatureBatch(layerId: number, actionId?: number, batchUpdateParamsVO?: BatchUpdateParamsVO, options?: any) {
        return UserLayersControllerApiFp(this.configuration).updateLayerFeatureBatch(layerId, actionId, batchUpdateParamsVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} layerId ID vrstvy
     * @param {number} [actionId] ID akce
     * @param {string} [progressId] Klientem vygenerované ID, pod kterým lze průběh ukládání dotazovat přes getFeatureBatchProgress
     * @param {Array<FeatureWrapperVO>} [featureWrapperVO] Hromadná editace více featur, každá s vlastní geometrií (např. přesun mnoha objektů najednou). Uloží se v jedné transakci.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLayersControllerApi
     */
    public updateLayerFeaturesBatch(layerId: number, actionId?: number, progressId?: string, featureWrapperVO?: Array<FeatureWrapperVO>, options?: any) {
        return UserLayersControllerApiFp(this.configuration).updateLayerFeaturesBatch(layerId, actionId, progressId, featureWrapperVO, options).then((request) => request(this.axios, this.basePath));
    }
}
